import currency from 'currency.js';

export const currencyFormat = (value: number | string) =>
    currency(value, {
        symbol: '',
        separator: ' ',
        precision: 2,
    }).format();